import * as React from 'react';
import Chip from '@mui/material/Chip';
import { styled } from '../../../../styles';

interface SelectMenuItemChipProps {
  title: string;
  bgColor?: string;
  color?: string;
}

export const SelectMenuItemChip: React.FC<React.PropsWithChildren<SelectMenuItemChipProps>> = ({
  bgColor,
  color,
  title
}) => <StyledChip size="small" label={title} $bgColor={bgColor} $color={color} />;

const StyledChip = styled(Chip)<{ $color?: string; $bgColor?: string }>`
  && {
    background-color: ${({ theme, $bgColor }) => $bgColor ?? theme.tokens.colorSurfaceVariant};
    color: ${({ theme, $color }) => $color ?? theme.tokens.colorOnSurfaceVariant};
    height: 17px;
    span {
      font-size: 10px;
      font-weight: 500;
    }
  }
`;
